// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ul26","colMaxWidth":"Table_colMaxWidth__3ZwDA"};